import { useAccountStore, winRate } from "../state/accountStore";
import { HeaderStats } from "./AppHeader";

/**
 * Trade's stats: running balance and win rate, on the always-visible primary
 * surface. Trade's counterpart to Predict's StatusBar. Like it, it renders
 * inside the shared AppHeader row rather than carrying a row of its own, so
 * the mode switcher sits on the same line as the numbers it belongs to.
 *
 * Average/biggest win/loss and the account reset are secondary (GRA-128):
 * they live in the session panel (HistoryPanel's SessionSummaryStrip)
 * instead, keeping this header row to the two numbers a player checks at a
 * glance.
 */
export function TradeStats() {
  const balance = useAccountStore((s) => s.balance);
  const stats = useAccountStore((s) => s.stats);

  return (
    <HeaderStats>
      <span>
        balance{" "}
        <span className="text-fg">
          ${balance.toLocaleString(undefined, { maximumFractionDigits: 2 })}
        </span>
      </span>
      {stats.trades > 0 && (
        <span>
          win rate <span className="text-fg">{Math.round(winRate(stats) * 100)}%</span>
          <span className="ml-1">({stats.wins}/{stats.trades})</span>
        </span>
      )}
    </HeaderStats>
  );
}
